import { useState } from "react"
import { Link } from "react-router-dom"
import { Button, Card, CardBody, CardTitle, DropdownMenu, DropdownToggle, Form, Input, UncontrolledDropdown } from "reactstrap"
import userAvatar from '../styles/user-avatar.jpeg'
import { mapToArray, sortAsc } from '../utils'
import PostImageModal from "./post-image-modal"

function FeedElem({ isUsersLoading, usersMap, crtUser, post, onDeletePost, onEditPost, onCreateComment, onEditComment, onDeleteComment, onReact, onUndoReaction, isProcessingReaction }) {
  const [newCommentText, setNewCommentText] = useState('')
  const [editingCommentId, setEditingCommentId] = useState(null)
  const [editingCommentText, setEditingCommentText] = useState('')
  const [isImgModalOpen, setIsImgModalOpen] = useState(false)

  const author = usersMap[post.userId]

  function formatDate(date) {
    return new Date(date).toLocaleString()
  }

  function handleDeletePost() {
    const shouldDelete = window.confirm('Are you sure?')

    if (shouldDelete) {
      onDeletePost(post.id)
    }
  }

  function handleCreateComment(evt) {
    evt.preventDefault()

    if (newCommentText) {
      onCreateComment(post.id, newCommentText, post.userId)
        .then(() => setNewCommentText(''))
    }
  }

  function handleEditComment(evt) {
    evt.preventDefault()

    if (editingCommentText) {
      onEditComment(editingCommentId, post.id, editingCommentText)
        .then(() => {
          setEditingCommentText('')
          setEditingCommentId(null)
        })
    }
  }

  function handleDeleteComment(commentId, postId) {
    const shouldDelete = window.confirm('Are you sure?')

    if (shouldDelete) {
      onDeleteComment(commentId, postId)
    }
  }

  function prepareAndSortComments(commentsMap) {
    return sortAsc(mapToArray(commentsMap))
  }

  function textOrPlaceholder(text) {
    if (isUsersLoading) {
      return <p className="placeholder-glow">
        <span className="placeholder col-8 placeholder-sm"></span>
      </p>
    }

    return text
  }

  function isLiked() {
    if (!post.reactions) return false

    const reaction = mapToArray(post.reactions).find(({ userId }) => crtUser.uid === userId)
    return !!reaction
  }

  function reactionClass() {
    let className = "bi"

    if (isLiked()) {
      return className + " bi-hand-thumbs-up-fill liked"
    }

    return className + " bi-hand-thumbs-up"
  }

  function handleReaction() {
    if (isLiked()) {
      const reactionId = mapToArray(post.reactions).find(({ userId }) => crtUser.uid === userId).reactionId
      onUndoReaction(reactionId, post.id)
    } else {
      onReact(post.id, post.userId)
    }
  }

  function handleImgModalToggle() {
    setIsImgModalOpen(!isImgModalOpen)
  }

  return <Card>
    <CardTitle tag="h6">
      <div className="post-user-date">
        <img src={author ? author.photoURL : userAvatar} alt="avatar" />
        <div>
          <div>{textOrPlaceholder(author ? author.displayName : '[Deleted User]')}</div>
          <div className="post-date">{textOrPlaceholder(formatDate(post.createdAt))}</div>
        </div>
      </div>
      {post.userId === crtUser.uid && <div className="post-author-actions">
        <UncontrolledDropdown setActiveFromChild key={post.id}>
          <DropdownToggle tag="span">
            <i className="bi bi-three-dots-vertical"></i>
          </DropdownToggle>
          <DropdownMenu>
            <div onClick={() => onEditPost(post.id)}>Edit</div>
            <div className="text-danger" onClick={handleDeletePost}>Delete</div>
          </DropdownMenu>
        </UncontrolledDropdown>
      </div>}
    </CardTitle>
    <CardBody className="pt-0">
      <p className="post-text">{post.text}</p>
      <div className="text-center">
        <img className="card-img" alt="Card" src={post.imageUrl} onClick={handleImgModalToggle} />
      </div>
    </CardBody>
    <div className="card-actions">
      <div>
        <Button color="light" size="sm" onClick={handleReaction} disabled={isProcessingReaction}>
          <i className={reactionClass()}></i>
        </Button>
        {!!mapToArray(post.reactions).length && <span className="reactions-count">
          {mapToArray(post.reactions).length}
        </span>}
      </div>
      <div>
        <Link to={"/coloring/" + post.drawingId} className="me-2" target="_blank">
          <i className="bi bi-box-arrow-up-right"></i>
        </Link>
      </div>
    </div>
    {post.comments && <div className="card-comments">
      {prepareAndSortComments(post.comments).map(comment =>
        <div key={comment.commentId}>
          <div className="post-comment-container">
            <img src={usersMap[comment.userId] ? usersMap[comment.userId].photoURL : userAvatar} alt="avatar" />
            <div className="post-comment-content">
              <div className="post-comment-autor">
                {textOrPlaceholder(usersMap[comment.userId] ? usersMap[comment.userId].displayName : '[Deleted User]')}
              </div>
              <div className="post-comment-text">
                {editingCommentId === comment.commentId ?
                  <Form className="card-comment-input" onSubmit={handleEditComment}>
                    <Input
                      size="sm"
                      value={editingCommentText}
                      onChange={evt => setEditingCommentText(evt.target.value)}
                    />
                  </Form>
                  : comment.text}
              </div>
            </div>
            {comment.userId === crtUser.uid && <div className="post-author-actions">
              <UncontrolledDropdown setActiveFromChild key={comment.commentId}>
                <DropdownToggle tag="span">
                  <i className="bi bi-three-dots-vertical"></i>
                </DropdownToggle>
                <DropdownMenu>
                  <div onClick={() => { setEditingCommentId(comment.commentId); setEditingCommentText(comment.text) }}>Edit</div>
                  <div className="text-danger" onClick={() => handleDeleteComment(comment.commentId, post.id)}>Delete</div>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>}
          </div>
        </div>
      )}
    </div>}
    <Form className="card-comment-input" onSubmit={handleCreateComment}>
      <img src={crtUser.photoURL || userAvatar} alt="avatar" />
      <Input
        size="sm"
        value={newCommentText}
        onChange={evt => setNewCommentText(evt.target.value)}
        placeholder="Write a comment..."
      />
    </Form>

    <PostImageModal isOpen={isImgModalOpen} onToggle={handleImgModalToggle} imageUrl={post.imageUrl} />
  </Card>
}

export default FeedElem
